import { httpPost } from "../httpService/httpService";

export const readNotification = async (apiBase: string, id: number, read: boolean): Promise<boolean> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/communication/${id}/notification-read?read=${read}`)
            .then((res: any) => {
                resolve(res.data as boolean);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const getMail = async (apiBase: string, userName: string): Promise<string> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/communication/user-email`, {userName: userName})
            .then((res: any) => {
                resolve(res.data as string);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const readMessage = async (apiBase: string, id: number, read: boolean): Promise<boolean> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/communication/${id}/message-read?read=${read}`)
            .then((res: any) => {
                resolve(res.data as boolean);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const importantMessage = async (apiBase: string, id: number, important: boolean): Promise<boolean> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/communication/${id}/message-important?important=${important}`)
            .then((res: any) => {
                resolve(res.data as boolean);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const sendMessage = async (apiBase: string, data: any): Promise<boolean> => {
    let formData = new FormData();
    const content = data.message.TRESC;
    data.receivers.forEach((receiver: string) => {
        formData.append('Receivers', receiver);
    })
    formData.append('Message', content);
    if (data.files !== null) {
        data.files.forEach((file: any) => {
            formData.append('Files', file);
        })
    }
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/communication/message-send`, formData)
            .then((res: any) => {
                resolve(res.data as boolean);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}
